const yup = require('yup')
const { requiredFields, labelify } = require('./helpers')

const shape = labelify({
  profile: yup.mixed(),
  total: yup.number().required().default(0),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
})

const connectionScoreHistorySchemaPartial = yup.object().shape(shape)
const connectionScoreHistorySchema = connectionScoreHistorySchemaPartial.shape(requiredFields(['profile'])(shape))

module.exports = { connectionScoreHistorySchema, connectionScoreHistorySchemaPartial }
